import ErrorShowComponent from '../../shared/errorShowComponent/errorShowComponent';
import s from './AuthInput.module.scss';

const Authinput = ({
  id,
  type = 'text',
  name,
  value,
  autoComplete = 'off',
  label,
  errorProp,
  touchedProp,
  cbOnChange,
}) => {
  return (
    <div className={s.group}>
      <input
        id={id}
        className={s.input}
        type={type}
        name={name}
        value={value}
        autoComplete={autoComplete}
        onChange={cbOnChange}
      />
      <label className={s.label} htmlFor={id}>
        {label}
      </label>
      <ErrorShowComponent errorProp={errorProp} touchedProp={touchedProp} />
    </div>
  );
};

export default Authinput;
